<div class="flex flex-col min-h-screen">
  <div class="flex flex-col flex-1 gap-5">
    <main class="flex-1">
      <router-outlet></router-outlet>
    </main>
  </div>

  <!-- Le footer est chargé uniquement quand il devient visible à l'écran (scroll) -->
  @defer (on viewport) {
  <app-footer></app-footer>
  } @placeholder {
  <div class="h-20"></div>
  }
</div>

@if (!cartService.isEmpty()) {
<div class="flex lg:hidden">
@if ((hideFloatingCartService.hide$ | async) === false) {
<!-- Le panier flottant est chargé quand le navigateur est au repos (idle) -->
@defer (on idle) {
<app-floating-cart></app-floating-cart>
}
}
</div>
}

<!-- Les cookies sont chargés au repos -->
@defer (on idle) {
<app-cookies></app-cookies>
}
